import { useSelector } from "react-redux";

import { WorkspaceLimitsDc } from "@evergis/api";

import { getWorkspace } from "../ducks/user";
import { checkLimits } from "../resources/resources";

export interface CheckLimitsResponse {
  limits: WorkspaceLimitsDc | undefined;
  loading: boolean;
  refetch: Refetch<WorkspaceLimitsDc>;
}

export const useCheckLimits = (immediate = true): CheckLimitsResponse => {
  const currentWorkspace: string = useSelector(getWorkspace);

  const {
    data: limits,
    loading,
    refetch,
  } = checkLimits.use({
    input: currentWorkspace,
    waitInput: true,
    immediate,
  });

  return { limits, loading, refetch };
};
